import { addTranslations } from '@fs/zion-locale'
import MediaBanners from './MediaBanners'
import {
  RootsTechBanner,
  RootsTechBannerCollapsed,
  RootsTechBannerExpanded,
  RootsTechBannerHeading,
  RootsTechBannerSubHeading,
  RootsTechBannerText,
  RootsTechBannerButton,
} from './RootsTechBanner'

import translations from './locales'

addTranslations(translations)

export default MediaBanners
export {
  RootsTechBanner,
  RootsTechBannerCollapsed,
  RootsTechBannerExpanded,
  RootsTechBannerHeading,
  RootsTechBannerSubHeading,
  RootsTechBannerText,
  RootsTechBannerButton,
}
